export const IMPERSONATION_BAR_HEIGHT_PX = 64;
